import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

// Connects to data-controller="resumin--date-picker"
export default class extends Controller {
  static targets = ["input"];
  static values = {
    displayId: String,
  };

  connect() {
    const input =
      this.element.type === "input" ? this.element : this.inputTarget;

    this.picker = flatpickr(input, {
      locale: Japanese,
      inline: true,
    });
    input.style.display = "none";
  }

  disconnect() {
    this.picker.destroy();
  }

  updateDate(e) {
    e.preventDefault();
    const displayId = this.displayIdValue;
    if (!displayId) {
      return;
    }

    const display = document.getElementById(displayId);
    display.innerText = this._formatDate(e.target.value);
  }

  _formatDate(date) {
    const parts = date.split("-");
    return `${parts[0]}年${parts[1]}月${parts[2]}日`;
  }
}
